import {type} from 'arktype'

export const ViewMode = type({
  'layout?': 'string',
  'action_type?': 'string',
  'navigation_type?': 'string',
  'card_type?': 'string',
  'type?': 'string',
})

export const Device = type({
  'portrait': [ViewMode, '|', 'number'],
  'landscape?': [ViewMode, '|', 'number'],
})

export const Representation = type({
  'tablet': Device,
  'mobile': Device,
  'desktop?': ViewMode,
})

export const SequenceOrder = type({
  desktop: 'number',
  tablet: Device,
  mobile: Device,
})

export const Parameter = type({
  'id': 'string',
  'value?': 'string',
})

export const Request = type({
  parameters: Parameter.array(),
})

export const TopNav = type({
  'desktop?': ViewMode,
  'tablet?': Device,
  'mobile?': Device,
})

export const SingleFeed = type({
  'id': 'string',
  'name': 'string',
  'representation': Representation,
  'sequence_order': SequenceOrder,
  'data_type': 'string',
  'feed_type': 'string',
  'retryable': 'boolean',
  'request': Request,
  'top_nav': TopNav,
  'max_number_of_items?': 'number',
  'description?': 'string',
})

export const Routes = type({
  'SINGLE_FEED?': SingleFeed,
})

export const Metadata = type({
  recommendation_name: 'string',
})

export const EnhancedFeed = type({
  'id': 'string',
  'name': 'string',
  'description?': 'string',
  'representation': Representation,
  'sequence_order': SequenceOrder,
  'data_type': 'string',
  'feed_type': 'string',
  'retryable': 'boolean',
  'request': Request,
  'top_nav': TopNav,
  'routes': Routes,
  'max_number_of_items?': 'number',
  'metadata?': Metadata,
})

export const Popular = type({
  enabled: 'boolean',
})

export const Spicy = type({
  enabled: 'boolean',
})

export const StyledText = type({
  text: 'string',
  text_style: 'string',
})

export const Pickup = type({
  value: 'number',
  currency: 'string',
  has_costing_required_options: 'boolean',
  required_price_with_choice_options: 'boolean',
  styled_text: StyledText,
})

export const Delivery = type({
  value: 'number',
  currency: 'string',
  has_costing_required_options: 'boolean',
  required_price_with_choice_options: 'boolean',
  styled_text: StyledText,
})

export const Features = type({
  SPICY: [Spicy, '|', 'boolean'],
  POPULAR: [Popular, '|', 'boolean'],
})

export const ItemPrice = type({
  pickup: Pickup,
  delivery: Delivery,
})

export const MediaImage = type({
  base_url: 'string',
  public_id: 'string',
  format: 'string',
  tag: 'string | string[]',
  scale_mode: 'string',
})

export const QuickAddConfiguration = type({
  state: 'string',
  action: 'string',
})

export const ChoiceOptionIdsMap = type({})

export const ChoiceOptionDataMap = type({})

export const Pagination = type({
  last_page: 'boolean',
})

export const FeaturesV3 = type({})

export const Entity = type({
  'item_id': 'string',
  'item_name': 'string',
  'item_description': 'string',
  'item_price': ItemPrice,
  'media_image?': MediaImage,
  'media_images': MediaImage.array(),
  'features': Features,
  'features_v2': Features,
  'features_v3': FeaturesV3,
  'quick_add_available': 'boolean',
  'quick_add_state': 'string',
  'quick_add_configuration': QuickAddConfiguration,
  'choice_option_ids_map': ChoiceOptionIdsMap,
  'choice_option_data_map': ChoiceOptionDataMap,
})

export const Content = type({
  'entity?': Entity,
  'type?': 'string',
})
export const Feed = type({})

export const Data = type({
  content: Content.array(),
  feed: Feed.array(),
  enhanced_feed: EnhancedFeed.array(),
})

export const MenuItemData = type({
  content: Content.array(),
})

export const MenuItemObject = type({
  request_id: 'string',
  operation_id: 'string',
  data: MenuItemData,
})
export const Object = type({
  request_id: 'string',
  operation_id: 'string',
  data: Data,
})

export const CategoryList = type({
  object: Object,
  status: 'string',
})

export type CategoryList = typeof CategoryList.infer

export const MenuItemListing = type({
  object: MenuItemObject,
  status: 'string',
})

export type MenuItemListing = typeof MenuItemListing.infer

export const CategoryListQuery = type({
  orderType: 'string',
  platform: 'string',
  enhancedFeed: 'boolean',
  weightedItemDataIncluded: 'boolean',
  location: 'string',
  viewport: 'string',
  restaurantId: 'string',
})

export type CategoryListQuery = typeof CategoryListQuery.infer

export const MenuItemListingQuery = type({
  'time': 'number',
  'location': 'string',
  'operationId': 'string',
  'isFutureOrder': 'boolean',
  'restaurantStatus': 'string',
  'brandUuid': 'string',
  'isNonRestaurantMerchant': 'boolean',
  'merchantTypes': 'string',
  'orderType': 'string',
  'pageSize?': 'number',
  'agent': 'boolean',
  'weightedItemDataIncluded': 'boolean',
  'task': 'string',
  'rpcVariant': 'string',
  'platform': 'string',
  'restaurantId': 'string',
  'menuItemId': 'string',
})
export type MenuItemListingQuery = typeof MenuItemListingQuery.infer
